import type { EventTags } from '@optimizely/optimizely-sdk'

import { Optimizely } from '@awazevr/mfe-common.lib.optimizely'

import {
  CORRELATION_ID_COOKIE_NAME,
  CORRELATION_ID_NOT_FOUND_REPLACEMENT,
} from '@/constants'
import { OptimizelyState } from '@/context/optimizely-decisions-context'
import { getCookie } from '@/utils/helpers'

export async function trackClientSideOptimizelyEvent(
  eventKey: string,
  optimizelyState: OptimizelyState,
  eventTags?: EventTags,
): Promise<void> {
  if (!optimizelyState?.dataFile) {
    return
  }
  const {
    dataFile,
    userId = '',
    brand = '',
    host = '',
    locale = '',
    userAgent,
    userDeviceType = '',
    isGuestApp = false,
  } = optimizelyState
  let optimizelyInst: Optimizely | undefined

  const correlationId =
    getCookie(CORRELATION_ID_COOKIE_NAME) ??
    CORRELATION_ID_NOT_FOUND_REPLACEMENT

  try {
    optimizelyInst = await Optimizely.getInstance({
      dataFile,
      eventBatchSize: 1,
      additionalConfig: {
        logLevel: 'ERROR',
      },
    })
    await optimizelyInst.trackEvent({
      eventKey,
      userId,
      ...(eventTags && { eventTags }),
      userAttributes: {
        application: 'search-mfe',
        brand,
        host,
        locale,
        isClientSide: true,
        userDeviceType,
        ...(userAgent && { $opt_user_agent: userAgent, userAgent }),
        isGuestApp,
      },
    })
  } catch (error: unknown) {
    newrelic?.noticeError(
      `Error tracking optimizely ${eventKey} event: ${error instanceof Error ? error.message : String(error)}`,
      { correlationId },
    )
  } finally {
    optimizelyInst?.close?.().catch((error) => {
      newrelic?.noticeError(`Error closing Optimizely: ${error.message}`, {
        correlationId,
      })
    })
  }
}
